import React from 'react';
import { connect } from 'react-redux';
import { PageBody, PageContent } from '@bit/knotchinc.web-react-components.page';
import FilterSideMenu from '@bit/knotchinc.web-react-components.filter-side-menu';
import DateFilter from '@bit/knotchinc.web-react-components.date-filter';
import ContentCard from 'components/Global/Card/ContentCard.jsx';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import ChecklistFilter from 'components/Global/Filters/ChecklistFilter/ChecklistFilter.jsx';
import TagFilter from 'components/Global/Filters/TagFilter/TagFilter.jsx';
// import SearchFilter from 'components/Global/Filters/SearchFilter/SearchFilter.jsx';
import SelectedFiltersBar from 'components/Global/Filters/SelectedFiltersBar/SelectedFiltersBar.jsx';
import { ContentFeedContainer } from 'components/Pages/Home/styled.js';
import { SET_KEYWORDS_FILTER, SET_CATEGORIES_FILTER } from 'components/Global/Filters/actions.js';
import Mixpanel from 'helpers/Mixpanel.js';
import { LeftSideBarWrapper } from '../styled.js';
import {
  fetchPartnershipKeywords,
  fetchPartnershipCategories,
  SET_PARTNERSHIP_CONTENT_FILTER,
  fetchPartnershipContent,
} from '../actions';

export class PartnershipPaidContentView extends React.Component {
  componentDidMount() {
    const { match: { params: { entityId, partnerId } } } = this.props;
    Mixpanel.track(`view Partnership Paid Content`, { entityId, partnerId });
  }

  render() {
    const { keywordsList, categoriesList, partnershipContentList, match,
      getKeywords, getCategories, getPartnershipFeed } = this.props;
    const { params: { entityId, partnerId, entityType } } = match;

    let brandId;
    let publisherId;

    if (entityType === 'brand') {
      brandId = entityId;
      publisherId = partnerId;
    } else {
      brandId = partnerId;
      publisherId = entityId;
    }


    return (
      <PageBody>
        <LeftSideBarWrapper>
          {/* <SearchFilter filterAction={SET_PARTNERSHIP_CONTENT_FILTER} /> */}
          <FilterSideMenu>
            <DateFilter filterAction={SET_PARTNERSHIP_CONTENT_FILTER} />
            <TagFilter
              title="keywords"
              type="keyword_tags"
              filters={partnershipContentList.filters}
              items={keywordsList}
              fetch={(clear) => getKeywords(clear, brandId, publisherId)}
              selectedItems={partnershipContentList.filters.keyword_tags}
              filterAction={SET_PARTNERSHIP_CONTENT_FILTER}
              listAction={SET_KEYWORDS_FILTER}
            />
            <ChecklistFilter
              type="categories"
              filters={partnershipContentList.filters}
              items={categoriesList}
              fetch={(clear) => getCategories(clear, brandId, publisherId)}
              selectedItems={partnershipContentList.filters.categories}
              filterAction={SET_PARTNERSHIP_CONTENT_FILTER}
              listAction={SET_CATEGORIES_FILTER}
            />
          </FilterSideMenu>
        </LeftSideBarWrapper>
        <PageContent>
          <SelectedFiltersBar
            filters={partnershipContentList.filters}
            filterAction={SET_PARTNERSHIP_CONTENT_FILTER}
            hiddenFilters={['brands', 'publishers', 'content_type']}
          />
          <ContentFeedContainer>
            <ListSync
              fetch={(clear) => getPartnershipFeed({ clear, brandId, publisherId })}
              listStore={partnershipContentList}
              loadOnScroll
              actionType={SET_PARTNERSHIP_CONTENT_FILTER}
              loadingPlaceholders={12}
            >
              <ContentCard />
            </ListSync>
          </ContentFeedContainer>
        </PageContent>
      </PageBody>
    );
  }
}

const mapStateToProps = ({
  PublishersList: { publishersList },
  BrandsList: { brandsList },
  KeywordsList: { keywordsList },
  CategoriesList: { categoriesList },
  PartnershipProfile: { partnershipContentList, metadata },
}) => ({ partnershipContentList, publishersList, categoriesList, keywordsList, brandsList, metadata });

const mapDispatchToProps = (dispatch) => ({
  getPartnershipFeed: ({ clear, brandId, publisherId }) => dispatch(fetchPartnershipContent(clear, brandId, publisherId)),
  setFilters: filters => dispatch({ type: SET_PARTNERSHIP_CONTENT_FILTER, filters }),
  getKeywords: (clear, brandId, publisherId) => dispatch(fetchPartnershipKeywords(clear, brandId, publisherId)),
  getCategories: (clear, brandId, publisherId) => dispatch(fetchPartnershipCategories(clear, brandId, publisherId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnershipPaidContentView);
